import React from 'react';
import { Link } from 'react-router-dom';
import './HeroText.css';

function HeroText() {
  return (
    <div className="hero-text-container">
      <div className="hero-label">
        <img src="/sparkle.png" alt="sparkle" className="sparkle-icon" />
        <span>Transit AI Suite</span>
      </div>
      <div className="hero-box">
        <h1>Redefining the Future of Transit - with AI That Moves People Forward</h1>
        <p>Every ride matters. Every second counts.
Transit Technologies is building the next era of mobility - where AI, automation, and intelligence empower agencies to deliver faster, safer, and more accessible service for all.
Built for public agencies.
Trusted by operators.
Designed for every rider.</p>
      </div>
      <Link to="/home" className="hero-button">Try it Out</Link>
    </div>
  );
}

export default HeroText;
